@use "../../../../../globals/settings";
@use "../../../../../globals/bcp";
@use "../../../../../globals/bcp-2022/objects/flyouts";
@use "../../../../../globals/bcp-2022/objects/links";

$self: ".notifications-flyout";

.notifications-flyout {
  &__list-item {
    @include flyouts.separator("bottom");
    display: flex;
    flex-direction: column;

    max-height: 160px;
    transition: max-height 0.3s ease-out;
    overflow: hidden;

    &__heading {
      display: flex;
      justify-content: space-between;

      .time {
        @include bcp.text-s;
        align-self: center;
        margin: 0;
      }

      &__action-buttons-group {
        margin-right: -12px;

        f-button {
          @include bcp.set-css-var(
            button-integrated,
            color,
            bcp.colorVar("link-text")
          );
          @include bcp.set-css-var(
            button-integrated-hover,
            color,
            bcp.colorVar("link-hover")
          );
        }
      }
    }

    &__main {
      display: flex;
      gap: bcp.size(8);
      padding-bottom: 10px;

      .read {
        font-weight: bcp.$font-weight-normal;
      }

      .unread {
        font-weight: bcp.$font-weight-bold;
      }
    }

    &__details {
      padding-bottom: 10px;

      a {
        @include bcp.set-css-var(link, text-decoration, none);
        @include bcp.set-css-var(link-hover, text-decoration, none);

        @include links.inline;
        @include links.with-icon;
        @include links.primary;
      }
    }
  }

  &__load-more {
    @include flyouts.load-more();
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
